<template>
  <div class="flex flex-col flex-1 w-full min-h-full">
    <MTab v-model="currentTab" position="left">
      <MTabPane v-for="tab in tabs" :key="tab.key" :tab="tab.title">
        <ScalarValuePropertyTab
          v-if="tab.key === 'scalar'"
          :resource-id="resourceId"
        />
        <TabularPropertyValueTab
          v-if="tab.key === 'tabular'"
          :resource-id="resourceId"
        />
      </MTabPane>
    </MTab>
  </div>
</template>

<script>
import ScalarValuePropertyTab from './scalar-property-value-tab'
import TabularPropertyValueTab from './tabular-property-value-tab'
export default {
  name: 'SnmpCustomPropertyTab',
  components: { ScalarValuePropertyTab, TabularPropertyValueTab },
  props: {
    resourceId: { type: Number, required: true },
  },
  data() {
    this.tabs = [
      { title: `${this.$tc('scalar')} ${this.$tc('property')}`, key: 'scalar' },
      {
        title: `${this.$tc('tabular')} ${this.$tc('property')}`,
        key: 'tabular',
      },
    ]
    return {
      currentTab: 'scalar',
    }
  },
}
</script>
